// Internal Imports
import {
  // Grid Related Functions
  generateMetaDataForTable,

  // Column Related Functions
  generateColumnDef,

  // Row Related Functions
  generateDiscountReduxData,
  generateGroupData,
  generateRowData,
  generateRowDataFromAPI,
  generateRowRippleEffects,
  handleIsBasePriceDynamic,
  handleIsCellEditable,
  handleIsCellHasMinValue,
  handleIsCellPopUp,
  handleNetPriceRounding,
  handlePercentageOfTotal,
  mapProductsToDealTable,
  saveDealTableRows,
  updateDealDiscountData,
  updateDealDiscountToBackEnd,
  updateDealTableRows,
  updateGroupData,
  updateProductCatalogFlags,
} from "../mutations";

export const ADD_PRODUCTS_TO_DEALTABLE_CONFIGURATION = [
  {
    name: "",
    description: "",
    method: updateProductCatalogFlags,
  },
  {
    name: "",
    description: "",
    method: mapProductsToDealTable,
  },
  {
    name: "",
    description: "",
    method: handleNetPriceRounding,
  },
  {
    name: "Calculate Percentage of Total",
    description: "POT is a special pricing type",
    method: handlePercentageOfTotal,
  },
  {
    name: "",
    description: "",
    method: handleNetPriceRounding,
  },
  {
    name: "",
    description: "",
    method: saveDealTableRows,
  },
  {
    name: "",
    description: "",
    method: handleIsCellEditable,
  },
  {
    name: "",
    description: "",
    method: handleIsBasePriceDynamic,
  },
  {
    name: "",
    description: "",
    method: handleIsCellHasMinValue,
  },
  {
    name: "",
    description: "",
    method: handleIsCellPopUp,
  },
  {
    name: "",
    description: "",
    method: generateGroupData,
  },
  {
    name: "",
    description: "",
    method: generateDiscountReduxData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountToBackEnd,
  },
];

export const ADD_PRODUCTS_TO_DEALTABLE_CONFIGURATION_V2 = [
  {
    name: "",
    description: "",
    method: updateProductCatalogFlags,
  },
  {
    name: "",
    description: "",
    method: generateRowDataFromAPI,
  },
  {
    name: "",
    description: "",
    method: handleIsCellEditable,
  },
  {
    name: "",
    description: "",
    method: handleIsBasePriceDynamic,
  },
  {
    name: "",
    description: "",
    method: handleIsCellHasMinValue,
  },
  {
    name: "",
    description: "",
    method: handleIsCellPopUp,
  },
  {
    name: "",
    description: "",
    method: generateDiscountReduxData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountToBackEnd,
  },
];

export const COLUMN_CONFIGURATION = [
  {
    name: "",
    description: "",
    method: generateColumnDef,
  },
];

// export const NET_PRICING_CONFIGURATION = [
//   {
//     name: "Round Up NetPrice",
//     description: "RoundUp NetPrice value based on the roundBy option selected",
//     method: roundUpNetPrice,
//   },
//   {
//     name: "Calculate Percentage of Total",
//     description: "POT is a special pricing type",
//     method: handlePercentageOfTotal,
//   },
//   {
//     name: "Round Up NetPrice",
//     description: "RoundUp NetPrice value based on the roundBy option selected",
//     method: roundUpNetPrice,
//   },
//   {
//     name: "",
//     description: "",
//     method: saveDealTableRows,
//   },
//   {
//     name: "Generate Discount Data",
//     description: "Generate group & deal level discount data",
//     method: updateDealDiscountData,
//   },
// ];

export const ROW_CONFIGURATION = [
  {
    name: "",
    description: "",
    method: generateRowData,
  },
  {
    name: "",
    description: "",
    method: handleIsCellEditable,
  },
  {
    name: "",
    description: "",
    method: handleIsBasePriceDynamic,
  },
  {
    name: "",
    description: "",
    method: handleIsCellHasMinValue,
  },
  {
    name: "",
    description: "",
    method: handleIsCellPopUp,
  },
  {
    name: "",
    description: "",
    method: generateDiscountReduxData,
  },
  {
    name: "Generate Discount Data",
    description: "Generate group & deal level discount data",
    method: updateDealDiscountData,
  },
];

export const ROW_RIPPLE_EFFECT_CONFIGURATION = [
  {
    name: "Row Ripple Effect",
    description:
      "On change of a cell value, it has some side-effects to be taken care of",
    method: generateRowRippleEffects,
  },
  {
    name: "",
    description: "",
    method: handleNetPriceRounding,
  },
  {
    name: "Calculate Percentage of Total",
    description: "POT is a special pricing type",
    method: handlePercentageOfTotal,
  },
  {
    name: "",
    description: "",
    method: handleNetPriceRounding,
  },
  {
    name: "",
    description: "",
    method: updateDealTableRows,
  },
  {
    name: "",
    description: "",
    method: updateGroupData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountData,
  },
  {
    name: "",
    description: "",
    method: updateDealDiscountToBackEnd,
  },
];

export const TABLE_CONFIGURATION = [
  {
    name: "",
    description: "",
    method: generateMetaDataForTable,
  },
];

export const PARSER = {
  columnParser: [TABLE_CONFIGURATION, COLUMN_CONFIGURATION],
  rowParser: [ROW_CONFIGURATION],
  addProductsToDealTableParser: [ADD_PRODUCTS_TO_DEALTABLE_CONFIGURATION],
  addProductsToDealTableParserV2: [ADD_PRODUCTS_TO_DEALTABLE_CONFIGURATION_V2],
  onCellChangeParser: [ROW_RIPPLE_EFFECT_CONFIGURATION],
  // netPriceRoundingParser: [NET_PRICING_CONFIGURATION],
};
